<template>
	<div class="col mobile-container none-select" v-if="main.length && tips.length">
		<img src="@/assets/question/bg.png" class="bg" />
		<div class="col guide-main">
			<div class="row title">
				<img src="@/assets/question/i.png" alt="" />
				<span>考试提醒</span>
			</div>
			<div class="col text-main">
				<div class="col">
					<span v-for="(item, key) in main" :key="key">{{ item }}</span>
				</div>
				<div class="col">
					<span v-for="(item, key) in tips" :key="key">{{ item }}</span>
				</div>
			</div>
			<div class="row sub-btn link" @click="startExam">开始考试</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		mode: {
			type: String,
			default: 'exam'
		}
	},
	data() {
		return {
			main: [],
			tips: []
		};
	},
	created() {
		if (!this.$store.getters.getToken) {
			this.navToForbidden();
		} else {
			this.service2('client/exam/tips', { order_id: this.$route.query.id }).then(res => {
				this.main = res.data.main;
				this.tips = res.data.tips;
			});
		}
	},
	methods: {
		navToForbidden() {
			this.$router.replace({
				path: '/' + this.mode + '/login'
			});
		},
		startExam() {
			this.service2('client/exam/confirm', { order_id: this.$route.query.id }).then(res => {
				this.$router.push({
					name: this.mode,
					params: {
						name: 'list'
					},
					query: {
						id: res.data.exam_log_id
					}
				});
			});
		}
	}
};
</script>

<style scoped lang="less">
@import './Guide.less';
</style>
